"use client";
import { useState, useEffect } from "react";

import { getContractUsageRules } from "services/contracts";

import LoaderContractModalWrapper from "components/loader-contract-modal-wrapper";
import Loader from "components/loader";

const UsesRulesContents = () => {
  const [content, setContent] = useState();

  const getContractRules = async () => {
    try {
      const response = await getContractUsageRules();
      setContent(response?.result);
    } catch (error) {
      console.error("Error fetching contract: ", error);
    }
  };

  useEffect(() => {
    getContractRules();
  }, []);

  return (
    <>
      {content ? (
        <div dangerouslySetInnerHTML={{ __html: content }} />
      ) : (
        <LoaderContractModalWrapper>
          <Loader />
        </LoaderContractModalWrapper>
      )}
    </>
  );
};

export default UsesRulesContents;
